import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=fe29a760&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&id=fe29a760&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe29a760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe29a760')) {
      api.createRecord('fe29a760', component.options)
    } else {
      api.reload('fe29a760', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=fe29a760&scoped=true&", function () {
      api.rerender('fe29a760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/slider.vue"
export default component.exports